import ApplicationState from "@insite/client-framework/Store/ApplicationState";

export function getReleaseNumber(state: ApplicationState): string {
    return (state as any).tData.releaseNumberState.releaseNumber;
}
